"use client";

import { ClipboardCheck } from "lucide-react";

import { QuoteForm } from "@/app/(authenticated)/quote-enroll/_modules/components/QuoteForm";
import type { TechficientQuoteFormCardData } from "../../types/insurabot-cards";

const S =
  "rgba(0,0,0,0.06) 0px 0px 0px 1px, rgba(0,0,0,0.03) 0px 1px 2px, rgba(0,0,0,0.02) 0px 4px 12px -2px";

/**
 * Inline quote form rendered inside an InsuraBot chat message. Reuses the
 * same QuoteForm component the /quote-enroll page uses, so a quote run from
 * chat behaves exactly like a quote run from the dedicated page. Results
 * render inside the form itself (carrier strip with Apply buttons), so the
 * agent never leaves the chat to enroll.
 *
 * Pre-fill values come from `data` — backend builds them from the lead the
 * AI thinks the agent is talking about. Anything missing the agent fills in.
 */
export default function TechficientQuoteFormCard({
  data,
}: {
  data: TechficientQuoteFormCardData;
}) {
  return (
    // w-full + min-w-0: bound the card to the chat width so the carrier
    // scroll-row inside can't stretch it (and the form) super wide.
    <div
      className="mt-3 w-full min-w-0 max-w-full rounded-lg overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-500"
      style={{ boxShadow: S }}
    >
      <div className="bg-gradient-to-br from-primary/5 to-white px-4 py-3 border-b">
        <p className="text-[9px] font-bold text-primary uppercase tracking-[0.1em] inline-flex items-center gap-1">
          <ClipboardCheck className="h-3 w-3" />
          Quote builder
        </p>
        {data.hint && (
          <p className="text-[11px] text-gray-600 mt-1">{data.hint}</p>
        )}
      </div>
      <div className="bg-white px-4 py-3 min-w-0">
        <QuoteForm
          preset={{
            leadId: data.leadId,
            leadName: data.leadName,
            birthDate: data.birthDate,
            gender: data.gender,
            state: data.state,
            zipCode: data.zipCode,
            heightInches: data.heightInches,
            weightPounds: data.weightPounds,
            tobaccoUse: data.tobaccoUse,
            coverageType: data.coverageType,
            faceAmount: data.faceAmount,
            termYears: data.termYears,
          }}
        />
      </div>
    </div>
  );
}
